import {isArrayNullUndefinedOrEmpty} from "../../../../services/Validator";
import ExerciserResultsQuestionItem from "../../../items/courses/exercisers/ExerciserResultsQuestionItem";

export default function ExerciserResultsQuestionsList({questions}) {
    // Used in FlashResultsScreen to display list of current
    // flash questions

    // BUILD
    if (isArrayNullUndefinedOrEmpty(questions))
        return null;
    return (
        <div className={"w-full grow flex flex-col justify-start py-10 space-y-6"}>
            {questions?.map((question, index) => (
                <ExerciserResultsQuestionItem key={index}
                                         index={index}
                                         total={questions.length}
                                         question={question} />
            ))}
        </div>
    );
}